import * as PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ScreenInfoMessage.less';

const ScreenInfoMessage = ({text}) => (
  <div className={styles.dlScreenInfoMessage}>{text}</div>
);

ScreenInfoMessage.displayName = 'ScreenInfoMessage';

ScreenInfoMessage.propTypes = {
  text: PropTypes.string,
};

ScreenInfoMessage.defaultProps = {
  text: '',
};

export default ScreenInfoMessage;
